<template>
    <div class="noticeDetails">
        <div>
            <div>{{details.title}}</div>
            <div>{{details.createDate}}</div>
            <div>{{details.content}}</div>
            <div v-if="details.announcementFiles!=''">
                <div>相关文件下载</div>
                <div>
                    <div class="pointer blue" v-for="(item,index) in details.announcementFiles" :key="index"
                        @click="downLoad(item.fileName,item.fileLink)">
                        <i class="el-icon-document blue"></i>{{item.fileName}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NoticeDetails",
        data() {
            return {
                details: {
                    announcementFiles: [],
                    businessNo: null,
                    content: null,
                    createDate: null,
                    id: null,
                    switchKg: null,
                    title: null
                }
            }
        },
        created() {
            this.details = this.$route.query;
        },
        methods: {
            downLoad(name, url) {
                // window.open(url);
                let a = document.createElement('a');
                a.setAttribute('target', '_blank');
                a.setAttribute('href', url);
                a.setAttribute('download', name);
                a.click();

                let fileUrl = 'http://view.xdocin.com/xdoc?_xdoc=' + url;
            }
        }
    };
</script>

<style scoped>
    .noticeDetails {
        background: #FFFFFF;
        text-align: left;
        padding-bottom: 50px;
    }

    .noticeDetails>div {
        width: 1200px;
        margin: 0 auto;
    }

    .noticeDetails>div>div:nth-child(1) {
        font-size: 28px;
        font-weight: bold;
        color: #333333;
        padding-top: 40px;
        text-align: center;
    }

    .noticeDetails>div>div:nth-child(2) {
        font-size: 14px;
        color: #999999;
        margin-top: 24px;
        text-align: center;
    }

    .noticeDetails>div>div:nth-child(3) {
        font-size: 14px;
        color: #666666;
        margin-top: 20px;
        line-height: 20px;
    }

    .noticeDetails>div>div:nth-child(4) {
        height: 90px;
        background: #F3F9FF;
        border-radius: 10px;
        margin-top: 50px;
        padding: 24px;
        box-sizing: border-box;
    }

    .noticeDetails>div>div:nth-child(4)>div:nth-child(1) {
        font-size: 14px;
        color: #333333;
    }

    .noticeDetails>div>div:nth-child(4)>div:nth-child(2) {
        display: flex;
        font-size: 12px;
        margin-top: 18px;
    }
</style>



// WEBPACK FOOTER //
// src/view/notice/noticeDetails.vue